import React, { useState, createContext, useContext } from 'react';
export interface Answers {
  revenue?: string;
  database?: string;
  providers?: string;
  adspend?: string;
  leadsource?: string;
  comfort?: string;
  filming?: string;
  capacity?: string;
}
interface AnswersContextValue {
  answers: Answers;
  setAnswer: (key: keyof Answers, value: string) => void;
}
const AnswersContext = createContext<AnswersContextValue | undefined>(undefined);
const STORAGE_KEY = 'pps_answers_v1';
function loadFromStorage(): Answers {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
function saveToStorage(answers: Answers) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(answers));
  } catch {
    /* storage disabled — fail silently */
  }
}
export function AnswersProvider({
  children
}: {
  children: ReactNode;
}) {
  const [answers, setAnswers] = useState<Answers>(() => loadFromStorage());
  const setAnswer = (key: keyof Answers, value: string) => {
    setAnswers(prev => {
      const next = {
        ...prev,
        [key]: value
      };
      saveToStorage(next);
      return next;
    });
  };
  return <AnswersContext.Provider value={{
    answers,
    setAnswer
  }} data-id="element-140">
      {children}
    </AnswersContext.Provider>;
}
export function useAnswers() {
  const ctx = useContext(AnswersContext);
  if (!ctx) throw new Error('useAnswers must be used within AnswersProvider');
  return ctx;
}